import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Clothes } from 'src/app/models/Clothes';
import { Family } from 'src/app/models/Family';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportSales } from 'src/app/models/ResponseReportSales';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ClothesService } from 'src/app/services/clothes.service';
import { FamilyService } from 'src/app/services/family.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any; 

@Component({
  selector: 'app-close-day',
  templateUrl: './close-day.component.html',
  styleUrls: ['./close-day.component.scss']
})
export class CloseDayComponent implements OnInit {

  //titles: String[] = ['FECHA VENTA','FAMILIA', 'SUBFAMILIA','NOC','ARTÍCULO','TALLA','CANTIDAD','IMPORTE'];
    titles: String[] = ['FECHA VENTA','NOC','ARTÍCULO','TALLA','CANTIDAD','IMPORTE'];
    public types: String[] = ['ONLINE', 'TIENDA_FISICA'];

    public period : Date;
    public form: FormGroup;
    public dateSelect: Date;
    public typeSelect:String[]= [];
    public search : boolean = false;
    public total: number=0;
    //public displayedColumns: string[] = ['dateSales','family', 'subFamily','noc','clothes','size','amount','prices'];
    public displayedColumns: string[] = ['dateSales','noc','clothes','size','amount','prices'];
    
    @ViewChild(MatSort) sort: MatSort;
  
    public dataSource : MatTableDataSource<ResponseReportSales>;//ResponseReportSales[]; 
    public dataTotal : ResponseReportSales[]; 
    constructor( private reportService : ReportService,private clothesService: ClothesService, private spinner: NgxSpinnerService,private toastr: ToastrService, 
      private authService: AuthenticationService,private router: Router, private familyService: FamilyService) { }
  
    ngOnInit() {
      this.spinner.show();
      try{
        jQuery.getScript(CONSTANTES.menu);
      } catch(Error){
        this.router.navigate(['login']);
      }

      this.dateSelect = new Date();
      this.dateSelect.setHours(0, 0, 0, 0);
      this.form = new FormGroup({
        'dateSelect': new FormControl(this.dateSelect, Validators.required),
        'types': new FormControl('', Validators.required),
      });
      this.loadReport();
    }
  
    loadReport() {
      let reportOrder = new ReportOrder();
      reportOrder.searchReport = new SearchReport();
  
      if(this.typeSelect != null && this.typeSelect.length>0){
        reportOrder.searchReport.type = this.typeSelect.toString();
      }else{
        reportOrder.searchReport.type = null;
      }

      if(this.dateSelect != null){
        reportOrder.searchReport.closeDate = this.dateSelect;
      }else{
        reportOrder.searchReport.closeDate = null;
      }

      if (this.dateSelect == null) {
        this.toastr.info("DEBE SELECCIONAR FECHA");
      }else{
        this.search = false;
        this.spinner.show();
        this.reportService.getReportSalesOfDay(reportOrder).subscribe(
            data => {
              if (getToken(data)) {
                if(data.responseReportSales === null || data.responseReportSales.length===0){
                  this.search = false;
                  this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
                }else{
                  this.search = true;
                  this.dataSource = new MatTableDataSource(data.responseReportSales);
                  this.dataTotal = data.responseReportSales;
                  this.dataSource.sort = this.sort;
                }
              }
              this.spinner.hide();
            }, error => {
              this.toastr.error(error);
              this.spinner.hide();
              this.logOut();
            }
          );
      }
    }
    
    logOut() {
      let infoUser = {
        userName: localStorage.getItem("nid")
      }
      this.authService.logOut(infoUser).subscribe(
        data => {
          localStorage.clear();
          this.router.navigate(['login']);
        }
      );
    }
  
    getTotalCost() {
      this.total = 0;
      if(this.dataTotal != undefined && this.dataTotal != null && this.dataTotal.length != 0){
            this.dataTotal.forEach(element => {
        this.total += element.prices;
      });
      }
      return this.total;
    }

}
